export interface ExtractedError {
  message: string;
  details?: { code: string; message: string }[];
}

/** Normaliza un error de axios/servicio a {message, details} para el modal + agente. */
export function extractErrorInfo(error: any, fallback = 'Ocurrió un error inesperado.'): ExtractedError {
  const data = error?.response?.data;
  const message =
    data?.message || data?.error || data?.detail || error?.message || fallback;

  let details: { code: string; message: string }[] | undefined;
  const raw = data?.details || data?.errors || data?.validationErrors;
  if (Array.isArray(raw)) {
    details = raw
      .map((d: any) =>
        typeof d === 'string'
          ? { code: '', message: d }
          : { code: String(d.code ?? d.codigo ?? ''), message: String(d.message ?? d.mensaje ?? d.detail ?? '') }
      )
      .filter((d) => d.message);
  }
  return { message: String(message), details };
}
